/**
 * OneAmerica Category 1 demographic Single Pay calibration bands.
 *
 * Historical dataset: 0f9ec65420ab6295b9cc
 * Curves: 1664
 * Rows: 15269 (10394 historical + 4875 fresh missing-ladder/boundary points)
 * Artifact SHA-256: 8a9fb6ee35693f7394a8ee1e72ba11352d2972a29254f376037fc6d8168d7c2e
 *
 * Category 3 shares only the independently verified-identical historical tuples.
 * Its fresh lower-premium points are maintained as separate overrides.
 */

import type { PackedBandEntry } from './oneAmericaPricingUtils';
import rawBands from './oneAmericaCat1DemographicBands.data.json?raw';

export const OA_CAT1_DEMOGRAPHIC_SINGLE_PAY_AGES = [40, 45, 50, 55, 60, 65, 70, 75] as const;

export const OA_CAT1_DEMOGRAPHIC_BANDS = JSON.parse(rawBands) as Record<string, PackedBandEntry[]>;
